import { axios } from '@/utils/request'

const api = {
    dakejianList: '/adminapi/cdakejian/dakejianList',
    dakejianDetail: '/adminapi/cdakejian/dakejianDetail',
    editDakejian: '/adminapi/cdakejian/editDakejian',
  deleteDakejian: '/adminapi/cdakejian/dakejianDelete',
  dakejianDeleteAll: '/adminapi/cdakejian/dakejianDeleteAll',
  dakejianDownloadUrl: '/adminapi/cdakejian/dakejianDownloadUrl',
  editDo: '/adminapi/cdakejian/editDo',
  setShoupaiAll: '/adminapi/cdakejian/setShoupaiAll',
  setSaiquAll: '/adminapi/cdakejian/setSaiquAll',
  setEditDoAll: '/adminapi/cdakejian/editDoAll',
  setStatusAll: '/adminapi/cdakejian/setStatusAll',
}

export default api

export function getDakejianList(parameter) {
  return axios({
    url: api.dakejianList,
    method: 'get',
    params: parameter
  })
}

export function getDakejianDetail(parameter) {
  return axios({
    url: api.dakejianDetail,
    method: 'get',
    params: parameter
  })
}
export function editDakejian(parameter) {
  return axios({
    url: api.editDakejian,
    method: 'post',
    data: parameter
  })
}
export function deleteDakejian(parameter) {
  return axios({
    url: api.deleteDakejian,
    method: 'post',
    data: parameter
  })
}
export function setShoupaiAll(parameter) {
  return axios({
    url: api.setShoupaiAll,
    method: 'post',
    data: parameter
  })
}
export function setSaiquAll(parameter) {
  return axios({
      url: api.setSaiquAll,
      method: 'post',
      data: parameter
  })
}
export function setEditDoAll(parameter) {
  return axios({
    url: api.setEditDoAll,
    method: 'post',
    data: parameter
  })
}
export function setStatusAll(parameter) {
  return axios({
    url: api.setStatusAll,
    method: 'post',
    data: parameter
  })
}

export function dakejianDeleteAll(parameter) {
  return axios({
    url: api.dakejianDeleteAll,
    method: 'post',
    data: parameter
  })
}

export function getCDakejianDownloadUrl(parameter) {
  return axios({
    url: api.dakejianDownloadUrl,
    method: 'post',
    data: parameter
  })
}
export function editDo(parameter) {
  return axios({
    url: api.editDo,
    method: 'post',
    data: parameter
  })
}
